import { Branch } from '../../../dorian-shared/types/branch/Branch';
import { StepTypes } from '../../../dorian-shared/types/branch/BranchStep';

export function createNodeTree(nodesToReposition: Branch[]) {
  const tree: { [key: number]: number[] } = {};
  nodesToReposition.forEach((branch) => {
    const childIds: number[] = [];

    if (branch.gotoBranchId) {
      childIds.push(branch.gotoBranchId);
    }

    const choiceStep = branch.steps?.find((s) => s.stepTypeId === StepTypes.Choice);
    if (choiceStep) {
      const answerIds = choiceStep.answers?.map((answer) => answer.gotoBranchId) ?? [];
      childIds.push(...answerIds);
    }

    const checkStep = branch.steps?.find((s) => s.stepTypeId === StepTypes.Check);
    if (checkStep) {
      const switchIds = checkStep.switch?.map((route) => route.gotoBranchId) ?? [];
      childIds.push(...switchIds);
    }

    tree[branch.id] = [...new Set(childIds)].filter(Boolean);
  });
  return tree;
}
